var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.959 3H4.43989C3.64795 3 3 3.67513 3 4.50028V13.502C3 14.3271 3.64795 15.0023 4.43989 15.0023H14.5191L17.3989 18.0028V4.50028C17.3989 3.67513 16.7509 3 15.959 3ZM7.31912 9.7501C7.71669 9.7501 8.03898 9.41429 8.03898 9.00005C8.03898 8.58581 7.71669 8.25 7.31912 8.25C6.92156 8.25 6.59927 8.58581 6.59927 9.00005C6.59927 9.41429 6.92156 9.7501 7.31912 9.7501ZM10.9185 9.00005C10.9185 9.41429 10.5962 9.7501 10.1986 9.7501C9.80108 9.7501 9.47879 9.41429 9.47879 9.00005C9.47879 8.58581 9.80108 8.25 10.1986 8.25C10.5962 8.25 10.9185 8.58581 10.9185 9.00005ZM13.0793 9.7501C13.4768 9.7501 13.7991 9.41429 13.7991 9.00005C13.7991 8.58581 13.4768 8.25 13.0793 8.25C12.6817 8.25 12.3594 8.58581 12.3594 9.00005C12.3594 9.41429 12.6817 9.7501 13.0793 9.7501Z",
    fill: "#B0B7C3",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5598 6H8.04072C7.24878 6 6.60083 6.67513 6.60083 7.50028V16.502C6.60083 17.3271 7.24878 18.0023 8.04072 18.0023H18.1199L20.9997 21.0028V7.50028C20.9997 6.67513 20.3517 6 19.5598 6ZM10.9196 12.7501C11.3172 12.7501 11.6394 12.4143 11.6394 12.0001C11.6394 11.5858 11.3172 11.25 10.9196 11.25C10.522 11.25 10.1997 11.5858 10.1997 12.0001C10.1997 12.4143 10.522 12.7501 10.9196 12.7501ZM14.5179 12.0001C14.5179 12.4143 14.1956 12.7501 13.798 12.7501C13.4004 12.7501 13.0782 12.4143 13.0782 12.0001C13.0782 11.5858 13.4004 11.25 13.798 11.25C14.1956 11.25 14.5179 11.5858 14.5179 12.0001ZM16.6801 12.7501C17.0777 12.7501 17.4 12.4143 17.4 12.0001C17.4 11.5858 17.0777 11.25 16.6801 11.25C16.2825 11.25 15.9602 11.5858 15.9602 12.0001C15.9602 12.4143 16.2825 12.7501 16.6801 12.7501Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3b82445e7d165e290eff6bec99c84863.svg";
export { ForwardRef as ReactComponent };